import { ReactComponent as UserProtectionIcon } from '../assets/Icons/UserProtection.svg';
import { ReactComponent as UsersIcon } from '../assets/Icons/users.svg';
import { ReactComponent as EarthIcon } from '../assets/Icons/earth.svg';

export const ages = [
    { value: '0-4', label: '0-4' },
    { value: '5-9', label: '5-9' },
    { value: '10-12', label: '10-12' },
    { value: '13-15', label: '13-15' },
    { value: '16-18', label: '16-18' },
    { value: '18+', label: '18+' },
    { value: '18-22', label: '18-22' },
    { value: '23-65', label: '23-65' },
    { value: '65+', label: '65+' }
];

export const agesValues = ['0-4', '5-9', '10-12', '13-15', '16-18', '18+', '18-22', '23-65', '65+'];

export const weekDays = [
    { value: 'monday', label: 'Monday' },
    { value: 'tuesday', label: 'Tuesday' },
    { value: 'wednesday', label: 'Wednesday' },
    { value: 'thursday', label: 'Thursday' },
    { value: 'friday', label: 'Friday' },
    { value: 'saturday', label: 'Saturday' },
    { value: 'sunday', label: 'Sunday' },
]

export const addWeekValues = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday']
export const addDaysValues = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
export const allTimesValues = ['morning', 'afternoon', 'evening']

export const officeHours = [
    { value: 'morning', label: 'Morning' },
    { value: 'afternoon', label: 'Afternoon' },
    { value: 'evening', label: 'Evening' },
]

export const postToList = [
    { value: 'for_me', label: 'For Me', Icon: UserProtectionIcon },
    { value: 'first_connection_only', label: '1st Connection Only', Icon: UsersIcon },
    { value: 'anyone', label: 'Anyone', Icon: EarthIcon },
]

export const imageTypes = ["image/jpeg", "image/png", "image/jpg", "image/svg+xml"];

export const session_type = [
    { value: 'has_video_provided', key: 'Video/Teletherapy' },
    { value: 'inperson_session', key: 'In-person' },
    { value: 'psypact_provider', key: 'PSYPACT' },
]

export const group_accepting_from = [
    { value: 'all_providers', key: 'All Providers' },
    { value: 'first_connection', key: 'My Trusted Network Only' },
    { value: 'second_connection', key: 'My Trusted Network + Who They Trust' },
]

export const accordionData = [
    {
      id: 'panel1',
      question: 'Can I change my plan later?',
      answer:
        'Yes, you can change to a different plan at the end of an active subscription period or the free trial.',
    },
    {
      id: 'panel2',
      question: 'What is your cancellation policy?',
      answer:
        'You can cancel an active subscription 14 days before its expiration without being charged for a renewal. We do not provide refunds if you decide to stop using the subscription during your subscription term. You can cancel your subscription by emailing us at support@therapywordofmouth.com.',
    },
    {
      id: 'panel3',
      question: 'How does billing work?',
      answer:
        'We accept payments via credit card. If you would like to pay by ACH, please send us a message at support@therapywordofmouth.com.',
    },
    {
      id: 'panel4',
      question: 'Can I change my account email or password?',
      answer:
        'Yes, you can access and change your email or password by going to your account and selecting the "settings" section.',
    },
  ];
  
  export const detoxFacilityTypes = [22, 23, 26, 27, 28, 34, 36];

  export const suppressAlertPaths = [
    "/post/",
    "/profile/",
    "/referrals/",
    "/user-profile/",
  ];
  
  export const emailTypes = [
    {value: 'general_posts_email', label: "New Post"},
    {value: 'referals_share_profile_email', label: "Share Profile"},
    {value: 'referals_received_email', label: "Received Referral"},
    {value: 'availability_email', label: "Availability Update"},
    {value: 'referals_email', label: "Sent Referral"},
    {value: 'reactions_email', label: "Post Like"},
    {value: 'referral_reminder_email', label: "Referral Reminder"},
    {value: 'availability_self_email', label: "Self Availability Update"},
  ]

  export const notificationFilters = {
    'All': 'type',
    'Unread': 'not_seen',
    'My Posts': 'my_posts',
    'Replies to My Posts': 'replies_to_my_posts',
    'Posts from Others': 'others_posts'
  }